// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,

    /**
     * Unique Platform Identifier
     */
    PLATFORM: 'RESEARCH',

    /**
     * Backend APIs
     */
    IXFI_WS_API: 'https://stream.zen-ex.com/',
    IXFI_API: 'https://api.zen-ex.com/api/front/',
    COIN_INFO_API: 'https://coin-info.api.zen-ex.com/api/front/',
    IOS_APP_LINK: 'https://apps.apple.com/ro/app/ixfi/id1614823165',
    ANDROID_APP_LINK: 'https://play.google.com/store/apps/details?id=com.ixfi',

    /**
     * Application Related URLs
     */
    CDN_URL: 'https://cardex-static-assets-staging.s3.eu-central-1.amazonaws.com/',
    GRAPH_CDN_URL: 'https://cardex-static-assets-staging.s3.eu-central-1.amazonaws.com/',
    LANGUAGE_URL: 'assets/i18n/',
    DOMAIN: 'zen-ex.com',

    /**
     * Web URLs
     */
    IXFI_STAKING: 'https://earn.staging.zen-ex.com/',
    IXFI_EXCHANGE: 'https://staging.zen-ex.com/',
    IXFI_REWARDS: 'https://points.zen-ex.com/',
    IXFI_RESEARCH: 'https://research-staging.zen-ex.com/',
    IXFI_STATUS: 'https://status.zen-ex.com/',
    NFT_WEB_URL: 'https://nft.zen-ex.com/',
    IXFI_ABOUT: 'https://www.ixfi.com/go/about/',
    IXFI_BLOG: 'https://www.ixfi.com/blog/',
    IXFI_CARDS: 'https://cards-staging.zen-ex.com/',
    IXFI_TOKEN: 'https://staging.zen-ex.com/token/',

    /**
     * Third Party Affiliates
     */
    BINANCE_SPOT_WS_URL: 'wss://stream.binance.com:9443/',
    BINANCE_API_URL: 'https://api.binance.com/api/',
    INTERCOM_APP_ID: 'hll0wikw'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
